var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ad-create"},[_c('ad-save-dialog',{ref:"dialog",attrs:{"form":_vm.f,"title":_vm.$translate('create', 'ad'),"confirm":_vm.createAd,"after":_vm.after},on:{"update:form":function($event){_vm.f=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }